import { GeofenceType, UserGeofenceType } from 'constants/geofence';
import { Record } from 'immutable';
import { GeofenceRule, PolygonGeofenceRecord } from 'services/resources';

const defaultGeofence: PolygonGeofenceRecord = {
  dealership: 0,
  geofenceType: GeofenceType.USER_DEFINED,
  id: 0,
  name: '',
  polygon: [],
  type: UserGeofenceType.POLYGON,
};

export const geofenceRuleDefault: GeofenceRule = {
  actions: [],
  dealership: 0,
  geofence: defaultGeofence,
  id: 0,
  isActive: false,
  name: '',
  onEntry: false,
  onExit: false,
};

export const geofenceRuleFactory = Record(geofenceRuleDefault);
